import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-gray-900 border-b border-pink-600 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" data-discover="true" className="flex items-center space-x-3">
            <img 
              src="/images/favicon.webp" 
              alt="Galo Bet" 
              className="h-10 w-10 object-contain"
            />
            <div className="text-3xl font-bold bg-gradient-to-r from-pink-500 to-pink-700 bg-clip-text text-transparent">
              Galo Bet
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" data-discover="true" className="text-gray-300 hover:text-pink-400 transition-colors">
              Accueil
            </Link>
            <Link to="/guides" data-discover="true" className="text-gray-300 hover:text-pink-400 transition-colors">
              Guides
            </Link>
            <Link to="/reviews" data-discover="true" className="text-gray-300 hover:text-pink-400 transition-colors">
              Avis
            </Link>
            <Link to="/news" data-discover="true" className="text-gray-300 hover:text-pink-400 transition-colors">
              Actualités
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-300 hover:text-pink-400"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-800">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                data-discover="true"
                className="text-gray-300 hover:text-pink-400 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Accueil
              </Link>
              <Link
                to="/guides"
                data-discover="true"
                className="text-gray-300 hover:text-pink-400 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Guides
              </Link>
              <Link
                to="/reviews"
                data-discover="true"
                className="text-gray-300 hover:text-pink-400 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Avis
              </Link>
              <Link
                to="/news"
                data-discover="true"
                className="text-gray-300 hover:text-pink-400 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Actualités
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;

